<template>
  <div id="plandetail">
    <mt-header fixed :title="$t(title)">
      <mt-button
        icon="back"
        slot="left"
        onclick="window.history.go(-1)"
      ></mt-button>
    </mt-header>

    <div class="content">
      <p class="yqsy">{{ $t("预期年化收益率") }}</p>
      <p class="lvnum">{{ detail.annualized_returns }}</p>
      <p class="desclable">
        <span v-for="(val, key) in detail.flag">
          <span v-if="key < 1">
            {{ val }}
          </span>
          <span v-else> | {{ val }} </span>
        </span>
      </p>
    </div>
    <div class="content2">
      <div class="jygz">
        <span class="left">{{ $t("交易规则") }}</span>
        <!-- <span class="right"><a :href="detail.rule_url" style="color:#1296db">{{$t('查看规则')}}</a></span> -->
      </div>
      <div class="line"></div>
      <div class="dateline">
        <div class="top">
          <div class="left">{{ $t("买入") }}</div>
          <div class="middle">{{ $t("起息日") }}</div>
          <div class="right">{{ $t("到期日") }}</div>
        </div>
        <div class="middle_img"></div>
        <div class="bottom">
          <div class="left">{{ now_time }}</div>
          <div class="middle">{{ second_time }}</div>
          <div class="right">{{ third_time }}</div>
        </div>
      </div>
      <div class="descguize">
        <div v-for="val in detail.rule">{{ val }}</div>
      </div>
    </div>
    <div class="content2">
      <div class="jygz">
        <span class="left">{{ $t("产品亮点") }}</span>
      </div>
      <div class="line"></div>
      <div class="descguize">
        <div v-for="val in detail.specialty">{{ val }}</div>
      </div>
    </div>
    <div class="syed">
      {{ $t("剩余额度") }} {{ detail.surplus_amount }} {{ detail.coin_symbol }}
    </div>
    <div class="ljgm" @click="buyploy()">{{ $t("立即购买") }}</div>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from "mint-ui";
import { httpGetDetial } from "@/api/wealth";
import { parseTimeYmd } from "@/utils/index";
export default {
  data: function () {
    return {
      now_time: 0,
      second_time: 0,
      third_time: 0,
      detail: {},
      title: "",
      id: 0,
    };
  },
  activated() {
    this.title = this.$route.query.title;
    this.id = this.$route.query.id;
    this.getDetial();
    this.now_time = this.getNowFormatDate();
    this.second_time = this.getNowFormatDate2();
    this.third_time = this.getNowFormatDate3();
  },
  methods: {
    getDetial: function () {
      // 获取点击产品详细信息
      httpGetDetial({ id: this.id })
        .then((res) => {
          this.detail = res.data;
          console.log(this.detail);
          this.third_time = this.detail.end_time;
          if (this.third_time == 0) {
            this.third_time = "长期";
          }
        })
        .catch(() => {});
    },
    getNowFormatDate: function () {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    getNowFormatDate2: function () {
      var date = new Date();
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    getNowFormatDate3: function () {
      var date = new Date();
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * 2);
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    buyploy() {
      this.$router.push({
        path: "/buyploy",
        query: { id: this.id, title: this.title },
      });
    },
  },
};
</script>
<style lang="less" scoped>
#plandetail {
  width: 100%;
  height: 100%;
  overflow: scroll;
  position: fixed;
  background: #f6f6f6;
  padding-bottom: 88px;
  box-sizing: border-box;
  z-index: 10;
}
/*顶部*/
.header {
  width: 100%;
  height: 200px;
  position: relative;
}
.mint-header,
div {
  background: #ffffff;
  color: #212529;
}
.header .bg {
  width: 100%;
  height: 100%;
}
.content {
  border-top: 1px solid #e3e8ed;
  margin: 40px 0 0 0;
  width: 100%;
  height: 152px;
  background-color: #fff;
}
p {
  width: 100%;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  color: #212529;
}
.yqsy {
  margin: 28px 0 18px 0;
}
.lvnum {
  line-height: 33px;
  font-size: 33px;
  color: #1296db;
}
.desclable {
  margin: 28px 0 0 0;
  color: #8c92a8;
}
.content2 {
  margin: 10px 0;
  padding: 0 20px;
}
.jygz .left {
  font-size: 16px;
  line-height: 44px;
  color: #212529;
  font-weight: bold;
}
.jygz .right {
  font-size: 12px;
  line-height: 44px;
  color: #1296db;
  float: right;
}
.line {
  border-top: 1px solid #e3e8ed;
}
.descguize {
  padding: 10px 0 25px 0;
}
.descguize div {
  color: #a9afc8;
  font-size: 12px;
  line-height: 16px;
}
.syed {
  text-align: center;
  font-size: 12px;
  width: 100%;
  height: 33px;
  line-height: 33px;
  background-color: #d7e7fa;
  color: #1296db;
  position: fixed;
  bottom: 50px;
}
.ljgm {
  text-align: center;
  font-size: 18px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #1296db;
  color: #fff;
  position: fixed;
  bottom: 0;
}
.dateline {
  width: 100%;
  font-size: 12px;
  line-height: 16px;
  .top,
  .bottom {
    padding: 0 !important;
    line-height: 40px;
    height: 40px;
    width: 100%;
    position: relative;
    .left {
      color: #a9afc8;
      width: 30%;
      position: absolute;
      left: 0;
      top: 0;
      text-align: left;
    }
    .middle {
      color: #a9afc8;
      width: 40%;
      position: absolute;
      left: 30%;
      top: 0;
      text-align: center;
    }
    .right {
      color: #a9afc8;
      width: 30%;
      position: absolute;
      right: 0;
      top: 0;
      text-align: right;
    }
  }
  .middle_img {
    background: url("~@/assets/img/img_time.png") no-repeat center top;
    background-size: contain;
    height: 20px;
    width: 100%;
  }
}
</style>
